import { render, staticRenderFns } from "./RegionDropdown.vue?vue&type=template&id=c6844c02&"
import script from "./RegionDropdown.vue?vue&type=script&lang=js&"
export * from "./RegionDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports